import type {
  Element,
  Element_Meta,
  Element_Link,
  Page,
  Page_Redirect,
  Page_SeoData,
  Page_Unavailable,
} from "../../aysa_api/models/page.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseElement = (): Element => {
  return {};
};

export const decodeElement = (reader: Reader, length: number): Element => {
  const end = reader.pos + length;
  const message = createBaseElement();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.type = {
          $case: "meta",
          meta: decodeElement_Meta(reader, reader.uint32()),
        };

        break;
      case 2:
        message.type = {
          $case: "link",
          link: decodeElement_Link(reader, reader.uint32()),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeElement = (writer: Writer, message: Element): Writer => {
  if (message.type !== undefined) {
    switch (message.type.$case) {
      case "meta":
        encodeElement_Meta(
          writer.uint32(10).fork(),
          message.type.meta
        ).ldelim();

        break;
      case "link":
        encodeElement_Link(
          writer.uint32(18).fork(),
          message.type.link
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBaseElement_Meta = (): Element_Meta => {
  return {
    content: "",
  };
};

export const decodeElement_Meta = (
  reader: Reader,
  length: number
): Element_Meta => {
  const end = reader.pos + length;
  const message = createBaseElement_Meta();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 3:
        message.content = reader.string();

        break;
      case 1:
        message.type = {
          $case: "property",
          property: reader.string(),
        };

        break;
      case 2:
        message.type = {
          $case: "name",
          name: reader.string(),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeElement_Meta = (
  writer: Writer,
  message: Element_Meta
): Writer => {
  writer.uint32(26).string(message.content);
  if (message.type !== undefined) {
    switch (message.type.$case) {
      case "property":
        writer.uint32(10).string(message.type.property);

        break;
      case "name":
        writer.uint32(18).string(message.type.name);

        break;
    }
  }
  return writer;
};

export const createBaseElement_Link = (): Element_Link => {
  return {
    rel: "",
    href: "",
  };
};

export const decodeElement_Link = (
  reader: Reader,
  length: number
): Element_Link => {
  const end = reader.pos + length;
  const message = createBaseElement_Link();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.rel = reader.string();

        break;
      case 2:
        message.href = reader.string();

        break;
      case 3:
        message.hreflang = reader.string();

        break;
      case 4:
        message.media = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeElement_Link = (
  writer: Writer,
  message: Element_Link
): Writer => {
  writer.uint32(10).string(message.rel);
  writer.uint32(18).string(message.href);
  if (message.hreflang !== undefined) {
    writer.uint32(26).string(message.hreflang);
  }
  if (message.media !== undefined) {
    writer.uint32(34).string(message.media);
  }

  return writer;
};

export const createBasePage = (): Page => {
  return {};
};

export const decodePage = (reader: Reader, length: number): Page => {
  const end = reader.pos + length;
  const message = createBasePage();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.type = {
          $case: "seoData",
          seoData: decodePage_SeoData(reader, reader.uint32()),
        };

        break;
      case 2:
        message.type = {
          $case: "redirectUrl",
          redirectUrl: decodePage_Redirect(reader, reader.uint32()),
        };

        break;
      case 3:
        message.type = {
          $case: "unavailable",
          unavailable: decodePage_Unavailable(reader, reader.uint32()),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePage = (writer: Writer, message: Page): Writer => {
  if (message.type !== undefined) {
    switch (message.type.$case) {
      case "seoData":
        encodePage_SeoData(
          writer.uint32(10).fork(),
          message.type.seoData
        ).ldelim();

        break;
      case "redirectUrl":
        encodePage_Redirect(
          writer.uint32(18).fork(),
          message.type.redirectUrl
        ).ldelim();

        break;
      case "unavailable":
        encodePage_Unavailable(
          writer.uint32(26).fork(),
          message.type.unavailable
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBasePage_Redirect = (): Page_Redirect => {
  return {
    url: "",
    statusCode: 0,
  };
};

export const decodePage_Redirect = (
  reader: Reader,
  length: number
): Page_Redirect => {
  const end = reader.pos + length;
  const message = createBasePage_Redirect();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.url = reader.string();

        break;
      case 2:
        message.statusCode = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePage_Redirect = (
  writer: Writer,
  message: Page_Redirect
): Writer => {
  writer.uint32(10).string(message.url);
  writer.uint32(16).int64(message.statusCode);

  return writer;
};

export const createBasePage_SeoData = (): Page_SeoData => {
  return {
    title: "",
    elements: [],
    jsonLd: [],
  };
};

export const decodePage_SeoData = (
  reader: Reader,
  length: number
): Page_SeoData => {
  const end = reader.pos + length;
  const message = createBasePage_SeoData();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.title = reader.string();

        break;
      case 2:
        message.elements.push(decodeElement(reader, reader.uint32()));

        break;
      case 4:
        message.jsonLd.push(reader.string());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePage_SeoData = (
  writer: Writer,
  message: Page_SeoData
): Writer => {
  writer.uint32(10).string(message.title);
  for (const value of message.elements) {
    encodeElement(writer.uint32(18).fork(), value).ldelim();
  }
  for (const value of message.jsonLd) {
    writer.uint32(34).string(value);
  }

  return writer;
};

export const createBasePage_Unavailable = (): Page_Unavailable => {
  return {};
};

export const decodePage_Unavailable = (
  reader: Reader,
  length: number
): Page_Unavailable => {
  const end = reader.pos + length;
  const message = createBasePage_Unavailable();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePage_Unavailable = (
  writer: Writer,
  _message: Page_Unavailable
): Writer => {
  return writer;
};
